import { defineMessages } from 'react-intl';

var closeBtnMessages = defineMessages({
  ariaLabel: {
    id: "neptune.CloseButton.ariaLabel"
  }
});

export { closeBtnMessages as default };
//# sourceMappingURL=CloseButton.messages.mjs.map
